import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './api.config';

export interface ChangePasswordRequest {
  CurrentPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private readonly http: HttpClient) {}

  changePassword(request: ChangePasswordRequest) {
    return this.http.post<unknown>(`${API_BASE_URL}/Breeze/ChangePassword`, request);
  }
}
